import { combineReducers } from 'redux';

import type { InvoiceDataReducer } from './data';
import data from './data';
import type { InvoiceUIReducer } from './ui';
import ui from './ui';

export interface InvoiceReducer {
  ui: InvoiceUIReducer;
  data: InvoiceDataReducer;
}

export default combineReducers({
  ui,
  data
});
